export const fileToObjectUrl = (file: File) => URL.createObjectURL(file);
